/* @flow */

import { BUTTON_LAYOUT } from '../../../constants';

import { CLASS } from './class';

export let layoutStyle = `

    .${ CLASS.CONTAINER }.${ CLASS.LAYOUT }-${ BUTTON_LAYOUT.VERTICAL } .${ CLASS.TAGLINE } {
        display: none;
    }
`;



// WEBPACK FOOTER //
// ./src/components/button/templates/component/style/layout.js